/**
 * Guard modal-dialog registration when ModalClose button is missing (Safari addEventListener null).
 * Must load before assets/theme.js (generated asset — not API-editable).
 */
(function () {
  if (window.__wearthModalDefineGuard) return;
  window.__wearthModalDefineGuard = true;

  var nativeDefine = customElements.define.bind(customElements);
  customElements.define = function (name, Class, options) {
    if (name !== 'modal-dialog') {
      return nativeDefine(name, Class, options);
    }

    var Orig = Class;
    var SafeModal = class extends HTMLElement {
      constructor() {
        super();
        var close = this.querySelector('[id^="ModalClose-"]');
        if (close) {
          close.addEventListener('click', this.hide.bind(this, false));
        }
        this.addEventListener('keyup', function (event) {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
          this.addEventListener('pointerup', function (event) {
            if (
              event.pointerType === 'mouse' &&
              !event.target.closest('deferred-media, product-model')
            ) {
              this.hide();
            }
          });
        } else {
          this.addEventListener('click', function (event) {
            if (event.target === this) this.hide();
          });
        }
      }
    };

    Object.getOwnPropertyNames(Orig.prototype).forEach(function (key) {
      if (key === 'constructor') return;
      var desc = Object.getOwnPropertyDescriptor(Orig.prototype, key);
      if (desc) Object.defineProperty(SafeModal.prototype, key, desc);
    });

    return nativeDefine(name, SafeModal, options);
  };
})();
